import React from 'react'
import { Outlet } from 'react-router-dom'

function MainSupportTickets() {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default MainSupportTickets
